var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFolderOpen03({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "folder-open-03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.59999 3.33008C6.48953 3.33008 6.39999 3.41962 6.39999 3.53008V4.78887H9.31865C9.59531 4.78887 9.85961 4.90348 10.0487 5.10545L12.5173 7.7425H18.2V3.53008C18.2 3.41962 18.1104 3.33008 18 3.33008H6.59999ZM20.2 7.7425V3.53008C20.2 2.31505 19.215 1.33008 18 1.33008H6.59999C5.38496 1.33008 4.39999 2.31505 4.39999 3.53008V4.78887H3.60044C2.3859 4.78887 1.40002 5.77276 1.40039 6.98887C1.40068 7.93142 1.40102 9.23301 1.40102 10.1468L1.40093 19.2711C1.40091 21.1488 2.92314 22.6711 4.80092 22.6711L19.1997 22.6711C21.0774 22.6711 22.5996 21.149 22.5997 19.2712L22.6 9.94257C22.6 8.72752 21.615 7.7425 20.4 7.7425H20.2ZM3.60044 6.78887C3.48914 6.78887 3.40036 6.87853 3.40039 6.98825C3.40068 7.9308 3.40102 9.23267 3.40102 10.1468L3.40093 19.2711C3.40092 20.0443 4.02772 20.6711 4.80092 20.6711L19.1997 20.6711C19.9728 20.6711 20.5996 20.0444 20.5997 19.2712L20.6 9.94251C20.6 9.83205 20.5104 9.7425 20.4 9.7425H12.0837C11.807 9.7425 11.5427 9.62789 11.3537 9.42592L8.88499 6.78887H3.60044Z",
    fill: "#116584"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFolderOpen03);
export default __webpack_public_path__ + "static/media/ic-folder-open-03.5f050c110de84fa4b8231bc283a39fdf.svg";
export { ForwardRef as ReactComponent };